export type Environment = 'local' | 'dev' | 'stage' | 'prod'

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '::1', '[::1]']

export function getEnvironment(
	hostname: string = window.location.hostname,
): Environment | null {
	const host = hostname.toLowerCase()

	if (LOCAL_HOSTNAMES.includes(host)) return 'local'
	if (host.endsWith('.one')) return 'dev'
	if (host.endsWith('.review')) return 'stage'
	if (host.endsWith('.com')) return 'prod'

	return null
}
